import request from '@/utils/request'

/**
 * 查询门店要货统计列表（后台管理员接口）
 * @param {Object} params - 查询参数
 * @param {Number} params.pageNo - 当前页
 * @param {Number} params.pageSize - 每页数量
 * @param {String} params.month - 统计月份(格式: yyyy-MM)
 * @param {Number} params.storeId - 门店ID
 * @param {Number} params.merchantId - 商家ID
 * @param {Number} params.settleStatus - 结算状态: 0-未结算 1-已结算
 */
export function getStorePurchaseStatisticsList(params) {
  return request({
    url: '/api/retail/statistics/store-purchase/list',
    method: 'get',
    params: params
  })
}

/**
 * 获取门店要货统计详情
 * @param {Object} params - 查询参数
 * @param {Number} params.id - 统计记录ID
 */
export function getStorePurchaseStatisticsDetail(params) {
  return request({
    url: '/api/retail/statistics/store-purchase/detail',
    method: 'get',
    params: params
  })
}

/**
 * 结算门店要货统计
 * @param {Object} params - 查询参数
 * @param {Number} params.id - 统计记录ID
 */
export function settleStorePurchaseStatistics(params) {
  return request({
    url: '/api/retail/statistics/store-purchase/settle',
    method: 'post',
    data: params
  })
}

/**
 * 查询门店要货统计列表（用户端接口，带权限控制）
 * @param {Object} params - 查询参数
 * @param {Number} params.current - 当前页
 * @param {Number} params.size - 每页数量
 * @param {String} params.month - 统计月份(格式: yyyy-MM)
 */
export function getStorePurchaseStatistics(params) {
  return request({
    url: '/statistics/order/store/purchase/list',
    method: 'get',
    params: params
  })
}
